app.controller("UserPersonalNosController", ["$scope", "$uibModal", "$uibModalInstance", "Users",
    function ($scope, $uibModal, $uibModalInstance, Users) {

        $scope.save = function () {
            Users.listWithPersonalNos($scope.personalNos).then(function (data) {
                $uibModalInstance.close(data);
            })
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);